import React from 'react';
import { ASSETS_FOLDER } from '../../../../../../constants';
import { SCENE_TOP } from '../../../../../../content';
import * as Features from '../../../../../../utils/Features';
import './TopBg.css';

const TopBg = props => {
  const { posX } = props;

  const style0 = {
    visibility: posX <= SCENE_TOP.LIMIT_1.MAX ? 'visible' : 'hidden',
  };

  const style1 = {
    visibility:
      posX >= SCENE_TOP.LIMIT_1.MIN && posX <= SCENE_TOP.LIMIT_2.MAX
        ? 'visible'
        : 'hidden',
    opacity: Math.max(
      Math.min(
        (posX - SCENE_TOP.LIMIT_1.MIN) /
          (SCENE_TOP.LIMIT_1.MAX - SCENE_TOP.LIMIT_1.MIN),
        1
      ),
      0
    ),
  };

  const style2 = {
    visibility:
      posX >= SCENE_TOP.LIMIT_2.MIN && posX <= SCENE_TOP.LIMIT_3.MAX
        ? 'visible'
        : 'hidden',
    opacity: Math.max(
      Math.min(
        (posX - SCENE_TOP.LIMIT_2.MIN) /
          (SCENE_TOP.LIMIT_2.MAX - SCENE_TOP.LIMIT_2.MIN),
        1
      ),
      0
    ),
  };

  const style3 = {
    visibility: posX >= SCENE_TOP.LIMIT_3.MIN ? 'visible' : 'hidden',
    opacity: Math.max(
      Math.min(
        (posX - SCENE_TOP.LIMIT_3.MIN) /
          (SCENE_TOP.LIMIT_3.MAX - SCENE_TOP.LIMIT_3.MIN),
        1
      ),
      0
    ),
  };

  const skyPath = `${ASSETS_FOLDER}img/scene/top/sky/${
    Features.features.mobile ? 'small/' : ''
  }`;

  return (
    <div id="top-bg-wrap">
      <img
        className="top-bg-layer"
        src={`${skyPath}sky-0.jpg`}
        style={style0}
        alt=""
      />
      <img
        className="top-bg-layer"
        src={`${skyPath}sky-1.jpg`}
        style={style1}
        alt=""
      />
      <img
        className="top-bg-layer"
        src={`${skyPath}sky-2.jpg`}
        style={style2}
        alt=""
      />
      <img
        className="top-bg-layer"
        src={`${skyPath}sky-3.jpg`}
        style={style3}
        alt=""
      />
    </div>
  );
};

export default TopBg;



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/SceneTop/TopBg/TopBg.js